module.exports = __webpack_public_path__ + "media/check-image-tooltip.2af9103a.png";